import clsx from 'clsx'
import React from 'react'
import { useSelector } from 'react-redux'
import TradingViewWidget from 'react-tradingview-widget'

import './Chart.scss'

const Chart = ({ conversion }) => {
   const { isDarkTheme } = useSelector(state => state.theme)

   const [data, setData] = React.useState([])
   const [lastPrice, setLastPrice] = React.useState(400.23)
   const [low, setLow] = React.useState(320.11)
   const [high, setHigh] = React.useState(412.86)

   React.useEffect(() => {
      setData([
         ['day', 'a', 'b', 'c', 'd'],
         ['Mon', 20, 28, 38, 45],
         ['Tue', 31, 38, 55, 66],
         ['Wed', 50, 55, 77, 80],
         ['Thu', 77, 77, 66, 50],
         ['Fri', 68, 66, 22, 15],
      ])
      setLastPrice(400.23)
      setLow(320.11)
      setHigh(412, 86)
   }, [])

   if (!data) return null
   return (
      <div className={clsx('Chart', isDarkTheme && 'Chart--dark')}>
         <div className="Chart__header">
            <div className="Chart__header-left">
               <h2 className="Chart__header-heading">
                  {conversion.from.unit}/{conversion.to.unit}
               </h2>
               <div className="Chart__header-prices">
                  Last Price: {lastPrice} Low: {low} High: {high}
               </div>
            </div>
            <div className="Chart__header-right"></div>
         </div>
         <div className="Chart__chart">
            <TradingViewWidget
               symbol={conversion.from.unit + conversion.to.unit}
               theme={isDarkTheme ? 'DARK' : 'LIGHT'}
               locale="fr"
               height="400"
               autosize
            />
            {/* <GoogleChart
               rootProps={{ class: 'Chart__chart-container' }}
               width={'100%'}
               height={400}
               chartType="CandlestickChart"
               loader={<Loader />}
               data={data}
               options={{
                  legend: 'none',
                  bar: { groupWidth: '100%' }, // Remove space between bars.
                  candlestick: {
                     fallingColor: { strokeWidth: 0, fill: '#a52714' },
                     risingColor: { strokeWidth: 0, fill: '#0f9d58' },
                  },
               }}
            /> */}
         </div>
      </div>
   )
}

export default Chart
